import styled from 'styled-components';

const Wrapper = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 60%, #0f172a 100%);
  padding: 2rem;

  img {
    width: 90vw;
    max-width: 380px;
    display: block;
    margin-bottom: 2rem;
    opacity: 0.85;
    filter: drop-shadow(0 8px 32px rgba(99, 102, 241, 0.3));
  }

  h3 {
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 800;
    color: #f8fafc;
    letter-spacing: -0.03em;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.95rem;
    color: #64748b;
    margin-bottom: 1.75rem;
    max-width: 360px;
    line-height: 1.65;
  }

  a {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.9rem;
    font-weight: 700;
    color: #fff;
    text-decoration: none;
    padding: 0.7rem 1.5rem;
    border-radius: 10px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.4);
    transition: transform 0.15s, box-shadow 0.15s;
    text-transform: capitalize;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(99, 102, 241, 0.5);
    }
  }
`;

export default Wrapper;
